
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"stroke-width":"1.5","viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 0C7.083 0 5.726.836 4.962 1.864a5.148 5.148 0 00-.998 3.022v3.343h-.69c-.78 0-1.43.63-1.43 1.388v6.995c0 .758.65 1.388 1.43 1.388h11.451c.781 0 1.431-.63 1.431-1.388V9.617c0-.758-.65-1.388-1.43-1.388h-.69V4.886c0-.84-.235-1.993-.998-3.022C12.274.836 10.918 0 9 0zm0 1.543c1.475 0 2.239.536 2.748 1.221.509.686.698 1.59.698 2.122v3.343H5.554V4.886c0-.532.19-1.436.698-2.122C6.761 2.08 7.525 1.543 9 1.543zM3.434 9.77h11.132v6.686H3.434z","font-family":"sans-serif","overflow":"visible"}})])
          )
        }
      }
    